<template>
  <span class="badge bg-danger position-relative" :class="[cssClass, injectedClass]" v-if="displayedStatus === 'Deleted'">{{ displayedStatus }} <Special v-show="isSpecial" /><Accepted v-show="isAccepted" /></span>
  <span class="badge bg-warning text-dark position-relative" :class="[cssClass, injectedClass]" v-else-if="displayedStatus === 'Active'">{{ displayedStatus }} <Special v-show="isSpecial" /><Accepted v-show="isAccepted" /></span>
  <span class="badge bg-primary position-relative" :class="[cssClass, injectedClass]" v-else-if="displayedStatus === 'Accepted'">{{ displayedStatus }} <Special v-show="isSpecial" /><Accepted v-show="isAccepted" /></span>
  <span class="badge bg-info text-dark position-relative" :class="[cssClass, injectedClass]" v-else-if="displayedStatus === 'InProgress'">{{ displayedStatus }} <Special v-show="isSpecial" /><Accepted v-show="isAccepted" /></span>
  <span class="badge bg-success position-relative" :class="[cssClass, injectedClass]" v-else-if="displayedStatus === 'Completed'">{{ displayedStatus }} <Special v-show="isSpecial" /><Accepted v-show="isAccepted" /></span>
  <span class="badge bg-dark position-relative" :class="[cssClass, injectedClass]" v-else-if="displayedStatus === 'Finalized'">{{ displayedStatus }} <Special v-show="isSpecial" /><Accepted v-show="isAccepted" /></span>
  <span class="badge bg-danger text-dark position-relative" :class="[cssClass, injectedClass]" v-else-if="displayedStatus === 'Declined'">{{ displayedStatus }} <Special v-show="isSpecial" /><Accepted v-show="isAccepted" /></span>
  <span class="badge bg-success text-dark position-relative" :class="[cssClass, injectedClass]" v-else-if="displayedStatus === 'PurchaseOrderApproved'">{{ displayedStatus }} <Special v-show="isSpecial" /><Accepted v-show="isAccepted" /></span>
  <span class="badge bg-secondary position-relative" :class="[cssClass, injectedClass]" v-else>{{ displayedStatus }} <Special v-show="isSpecial" /><Accepted v-show="isAccepted" /></span>

  <span :class="cssClass"><small>{{ (dateCompleted && !dateCompleted.startsWith('0001')) ? $dayjs(dateCompleted).format('&nbsp; D MMM YY') : '' }}</small></span>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import Special from "./OrderBadgeSpecial.vue"
import Accepted from "./OrderBadgeAccepted.vue"

defineOptions({ name: "OrderBadge" })

const props = defineProps({
    cssClass: String,
    workOrder: {
      type: Object,
      default: () => ({}),
    },
  })

const status = computed(
  () =>
    props.workOrder?.statusText ||
    props.workOrder?.statusDisplay ||
    props.workOrder?.status ||
    props.workOrder?.Status ||
    "",
)
const dateCompleted = computed(() => props.workOrder?.dateCompleted || "")
const isSpecial = computed(() => props.workOrder?.isSpecial || false)
const isAccepted = computed(() => props.workOrder?.isAccepted || false)
const isInjected = computed(() => props.workOrder?.isInjected || false)

const statusFiltered = computed(() => (status.value?.includes("+") ? status.value.slice(0, -1) : status.value))

const displayedStatus = computed(() => {
  if (isInjected.value && statusFiltered.value === "Active") return "Accepted"
  return statusFiltered.value
})

const injectedClass = computed(() => (isInjected.value ? "border border-dark border-3" : ""))
</script>
